import React, { Component } from "react";

import WodRemaining from "../../services/wodremaining";
import {
  Icon,
  Modal,
  Header,
  Input,
  Button,
  Grid,
  Label
} from "semantic-ui-react";
import { hashHistory } from "react-router";
class CreateDerivative extends Component {
  constructor() {
    super();
    this.state = {
      maxbudget: null,
      remainingbudget: null,
      newwod: null,
      showModal: false,
      newderivative: null,
      newwonton: null,
      newbudget: null,
      created: false
    };
  }

  handlenewbudget(e) {
    console.log(this.state.maxbudget);
    let newderivbudget = e.target.value;
    if (newderivbudget < this.state.maxbudget) {
      this.setState({
        newbudget: newderivbudget,
        remainingbudget: WodRemaining(this.props.wod) - newderivbudget
      });
    } else {
      this.setState({
        newbudget: newderivbudget,
        remainingbudget: WodRemaining(this.props.wod) - newderivbudget
      });
    }
  }

  handleshow(meh) {
    this.setState({ showModal: meh });
  }
  genmsg() {
    var msg;
    if (this.state.created === true) {
      msg =
        this.state.newwonton +
        " Has been created with a budget of $" +
        this.state.newbudget +
        ". " +
        "Click Next to edit the new derivative.";
    } else if (this.state.created === false && this.props.wod !== null) {
      msg = "Enter the budget of New Derivative " + this.props.wod.workOrderNbr;
    }
    return msg;
  }
  genbtns() {
    if (this.state.created === false) {
      return (
        <div>
          <Button
            basic
            color="red"
            inverted
            onClick={() => this.setState({ showModal: false })}
          >
            <Icon name="remove" /> Cancel
          </Button>
          <Button
            color="green"
            inverted
            disabled={
              this.state.remainingbudget <= 0 || this.state.newbudget === 0
            }
            onClick={() => {
              this.props.handlecreatederiv(this.state.newbudget);
            }}
          >
            <Icon name="checkmark" /> Create Derivative
          </Button>
        </div>
      );
    } else {
      return (
        <Button color="blue" inverted onClick={() => this.handleredirect()}>
          Next <Icon name="chevron right" />
        </Button>
      );
    }
  }
  handleredirect() {
    if (this.state.created) {
      hashHistory.push("/work-orders/" + this.state.newwonton);
      window.location.reload();
    } else {
      this.setState({ showModal: false });
    }
  }
  handlebudgetmessage() {
    if (this.state.remainingbudget < 0) {
      return (
        <Label basic color="red" pointing>
          <h3>New budget can not be more than remaining budget.</h3>
        </Label>
      );
    }
  }
  gencontent() {
    if (!this.state.created && this.props.rootwod) {
      var available = WodRemaining(this.props.rootwod);

      return (
        <Grid>
          <Grid.Row centered>
            <p>Available Budget is ${available}</p>
          </Grid.Row>
          <Grid.Row centered>
            <Input
              error={this.state.remainingbudget < 0}
              icon="dollar"
              iconPosition="left"
              type="number"
              onChange={e => this.handlenewbudget(e)}
            />
          </Grid.Row>
          <Grid.Row centered>{this.handlebudgetmessage()}</Grid.Row>
        </Grid>
      );
    }
  }
  render() {
    return (
      <div className="CreateDerivative">
        <Modal
          basic
          open={this.state.showModal}
          onClose={() => this.setState({ showModal: false })}
          closeOnEscape={true}
          size="large"
          closeOnRootNodeClick={false}
        >
          <Header textAlign="center">{this.genmsg()}</Header>
          <Modal.Content>{this.gencontent()}</Modal.Content>
          <Modal.Actions>{this.genbtns()}</Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default CreateDerivative;



// WEBPACK FOOTER //
// ./src/components/wod/derivativemodal.jsx